/**
 * Inspections are keyed by the 5–6 digit serial.
 * ShedSuite also sends a longer serial; the last numeric group is that short serial.
 */
export function splitInspectionSerial(raw: string): { serial: string; longSerial: string } {
  const text = raw.trim();
  if (!text) return { serial: "", longSerial: "" };
  const parts = text.split("-").map((part) => part.trim()).filter(Boolean);
  const tail = parts[parts.length - 1] ?? "";
  if (parts.length > 1 && /^\d{5,6}$/.test(tail)) {
    return { serial: tail, longSerial: text };
  }
  return { serial: text, longSerial: "" };
}
